<template lang="pug">
  base-container
    avue-crud(
      ref="crud",
      :data="data",
      :table-loading="loading",
      :option="option",
      :page.sync="page",
      @search-change="searchChange",
      @search-reset="searchReset",
      @current-change="currentChange",
      @size-change="sizeChange",
      @refresh-change="refreshChange",
      @on-load="onLoad"
    )
      template(slot-scope="scope", slot="menuLeft")
        el-button(
          type="primary",
          icon="el-icon-plus",
          size="small",
          plain,
          @click.stop="handleAdd"
        ) 新增
      template(slot-scope="scope", slot="menu")
        el-button.none-border(
          icon="el-icon-view",
          type="text",
          size="small",
          plain,
          @click.stop="rowView(scope.row, scope.index)"
        ) 查看
        el-button.none-border(
          icon="el-icon-edit",
          type="text",
          size="small",
          plain,
          @click.stop="rowUpdate(scope.row, scope.index)"
        ) 更新
        el-button.none-border(
          icon="el-icon-delete",
          type="text",
          size="small",
          plain,
          @click.stop="rowDel(scope.row, scope.index)"
        ) 删除
</template>
<script>
/**
 * 内容管理-协议管理-列表
 */
const CONFIRM_TITLE = '确定将所选数据删除？'
import { getFaqList, delFaq } from '@/api/content'
import { ROUTER_FAQ_ADD_OR_UPDATE, ROUTER_FAQ_VIEW } from './const'

export default {
  name: 'Agreement',
  components: {},
  data() {
    return {
      form: {},
      data: [],
      query: {},
      loading: false,
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 0
      },
      option: {
        indexLabel: '编号',
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        addBtn: false,
        editBtnText: '更新',
        searchShow: true,
        columnBtn: false,
        searchBtnText: '查询',
        emptyBtnText: '重置',
        stripe: true,
        searchSpan: 8,
        searchMenuSpan: 7,
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        menuWidth: 200,
        menu: true,
        column: [
          {
            label: '主标题',
            prop: 'title',
            search: true,
            overHidden: true
          },
          {
            label: '备注',
            prop: 'comment',
            overHidden: true
          },
          {
            label: '创建时间',
            prop: 'createDate',
            type: 'daterange',
            valueFormat: 'yyyy-MM-dd hh:mm:ss',
            search: true,
            searchRange: true
          }
        ]
      }
    }
  },
  methods: {
    rowView(row) {
      const { id } = row
      this.$router.push({ path: ROUTER_FAQ_VIEW, query: { id }})
    },
    rowUpdate(row, index, loading, done) {
      const { id } = row
      this.$router.push({
        path: ROUTER_FAQ_ADD_OR_UPDATE,
        query: { id }
      })
    },
    handleAdd() {
      this.$router.push({
        path: ROUTER_FAQ_ADD_OR_UPDATE,
        query: { id: null }
      })
    },
    rowDel(row) {
      const { id } = row
      this.$confirm(CONFIRM_TITLE, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delFaq({ id }).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功',
            onClose: () => {
              this.onLoad(this.page)
            }
          })
        })
      })
    },
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    onLoad(page, params = {}) {
      const { createDate } = params
      let values = { ...params }
      if (createDate) {
        values = {
          ...params,
          createDateStart: createDate[0],
          createDateEnd: createDate[1]
        }
        values.createDate = null
        this.query.createDate = null
      }
      this.loading = true
      getFaqList(page.currentPage, page.pageSize, { ...values, ...this.query })
        .then((res) => {
          const data = res.data
          this.page.total = res.total
          this.data = data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
